export default __webpack_public_path__ + "static/gi-8801a4523cc407423cdbcc590ea9427e.svg";